/**
 * https://github.kakaocorp.com/kakaopage/api/blob/b7d95ad4f0/api/src/main/java/com/kakaopage/api/model/CommentStatus.java
 */
export enum CommentStatus {
  /**
   * 노출
   */
  Expose = 'N',
  /**
   * 권리침해 임시
   */
  Temp = 'T',
  /**
   * 클린시스템으로부터 운영자가 차단
   */
  BlockedByAdmin = 'A',
  BlockedByExid = 'B',
  /**
   * 사용자 삭제
   */
  Deleted = 'Y',
  /**
   * 사용자 차단
   */
  BlockedByUser = 'U',

  /**
   * API에서 내려주는 상태가 아닌 클라이언트 편의를 위해 Web에서 추가한 상태입니다.
   * 내가 삭제한 댓글에 한해 임시로 할당되는 상태입니다.
   */
  DeletedByMe = 'TEMP_D',
}
